<template>
  <div>

    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <p class="title is-5">Admission</p>
          </div>
        </div>
        <!-- <div class="level-right">
          <div class="buttons">
            <router-link class="button is-danger is-small btnicon" :to="{ name: 'FindAdmission', params: {} }" title="Create">Create new admission </router-link>
          </div>
        </div> -->
      </div>
      Total Records : <b>{{ total }}</b>
    </section>
    <card-component>
      <form @submit.prevent="getAdmission">
        <div class="columns">
          <div class="column is-3">
            <label class="label">From </label>
            <div class="control">
              <input class="input" type="date" :max="filter.toDate" v-model="filter.fromDate" required />
            </div>
          </div>
          <div class="column is-3">
            <label class="label">To </label>
            <div class="control">
              <input class="input" type="date" :max="maxToDate" v-model="filter.toDate" required />
            </div>
          </div>
          <div class="column is-3">
            <label class="label">Action</label>
            <button class="button is-success m-r-10" type="submit">Apply</button>
            <b-button @click="generateCSVData()" type="is-primary" icon-left="briefcase-download" v-show="total > 0">Download CSV </b-button>
          </div>
        </div>
      </form>
    </card-component>
    <section class="section is-main-section">
      <section></section>
      <card-component title="" class="has-table">
        <b-table :paginated="true" :per-page="10" :striped="true" :hoverable="true" detailed :data="admissionData">
          <template slot-scope="props">
<b-table-column label="Student Name" field="studentFirstName" sortable width="100">
              {{ props.row.studentEnrollment.studentName || '-' }}
            </b-table-column>
            <b-table-column label="Father Name" field="fatherName" sortable width="100">
              {{ props.row.studentEnrollment.fatherName || '-' }}
            </b-table-column>
            <b-table-column label="Father Mobile" field="fatherMobile" width="100">
              {{ props.row.studentEnrollment.fatherMobile || '-' }}
            </b-table-column>
            <b-table-column label="Enrollment Code" field="Enrollment Code" sortable width="100">
              {{ props.row.studentEnrollment.enrollmentCode || '-' }}
            </b-table-column>
<b-table-column label="Gender" field="gender" sortable width="100">
              {{ props.row.studentEnrollment.gender || '-' }}
            </b-table-column>
<b-table-column label="Class" field="class" sortable width="100">
              {{ props.row.class }}
            </b-table-column>
<b-table-column label="Section" field="section" sortable width="100">
              {{ props.row.section }}
            </b-table-column>
<b-table-column label="Admission Date" field="Admission date" sortable width="100">
              {{ props.row.dateOfAdmission }}
            </b-table-column>

          </template>
          <template slot="detail" slot-scope="props">
            <div class="columns">
              <div class="column is-4">
                <p><b>Mother mobile:</b> {{ props.row.studentEnrollment.motherMobile }}</p>
              </div>

              <div class="column is-4">
                <p><b>Mother email:</b> {{ props.row.studentEnrollment.motherEmailID }}</p>
              </div>
<div class="column is-4">
                <p><b>student Address:</b> {{ ((props.row.studentEnrollment.address1) ?  props.row.studentEnrollment.address1 +", " : '') +props.row.studentEnrollment.city+", "+props.row.studentEnrollment.state+", "+props.row.studentEnrollment.countryName+"-"+props.row.studentEnrollment.pincode }}</p>
              </div>
            </div>
          </template>
          <section class="section" slot="empty">
            <div class="content has-text-grey has-text-centered">
              <template v-if="isLoading">
                <p>
                  <b-icon icon="dots-horizontal" size="is-large" />
                </p>
                <p>Fetching data...</p>
              </template>
              <template v-else>
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>Nothing's here&hellip;</p>
              </template>
            </div>
          </section>
        </b-table>
      </card-component>
    </section>

  </div>
</template>
<script>
import CardComponent from '@/components/template/CardComponent'
import constants from '@/utils/constants'
import moment from 'moment'
import Utils from '@/utils'
import { mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'admission',
  props: ['radio2'],
  components: {
    CardComponent

  },
  data () {
    return {
      planAssignModal: false,
      isWrite: false,
      filterData: [],
      searchTerm: '',
      radio: 'all',
      total: 0,
      isLoading: false,
      loadingComponent: null,
      enableDocumentModal: false,
      enableSectionModal: false,
      admissionData: [],
      franchiseeID: '',
      findEnquiry: {
        academicYearID: '',
        searchType: 'mobileNo',
        searchKey: ''
      },
      filter: {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        academicYearID: '',
        stage: 'All'
      },
      maxToDate: moment().format('YYYY-MM-DD'),
      academicYears: [],
      stages: [],
      searchEnquiryObj: {
        academicYearID: '',
        searchType: 'studentmobile',
        searchKey: ''
      },
      studentPhotoURL: '',
      fatherPhotoURL: '',
      motherPhotoURL: '',
      birthCertificateURL: '',
      transferCertificateURL: '',
      immunisationCertificateURL: '',
      studentAadharCardURL: '',
      fatherAadharCardURL: '',
      motherAadharCardURL: '',
      healthCertificateURL: '',
      isDataLoaded: false,
      documentData: [],
      registrationData: []
    }
  },
  mounted: async function () {
    if (this.franchisee.id) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getAdmission()
    }
  },
  watch: {
    franchisee: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getAdmission()
    },
    academicYear: async function (val) {
      await this.onFranchiseeChange()
      await this.academics()
      await this.getAdmission()
    }
  },
  async created () {
    this.isWrite = Utils.helper.getIsWriteFun(this.$route)
    try {
      this.loadingComponent = this.$buefy.loading.open()
      const { data: questions } = await http.get(`${constants.API_URL}/api/enquiry-questions`)
      this.stages = questions.filter(obj => obj.type === 'INTEREST_TYPE')

      this.loadingComponent.close()
      //   await this.getAdmission()
      this.onFranchiseeChange()
    } catch (e) {
      this.loadingComponent.close()
      const errorMessage = (e && e.response && e.response.data.message) || e.message
      console.log('errorMessage', errorMessage)
    }

    if (this.radio2) {
      this.radio = this.radio2
    }
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  methods: {
    generateCSVData: async function () {
      if ((this.franchiseeID) && (this.academicYear)) {
        let response = ''
        response = await http.post(`${constants.API_URL}/api/download-admissiondatacsv/`, {
          franchiseeID: this.franchiseeID,
          academicYearID: this.academicYear.id,
          fromDate: this.filter.fromDate,
          toDate: this.filter.toDate
        })

        /** * download file */
        if (!_.isEmpty(response)) {
          const getCSVFileUrl = response.data.url
          await this.downloadCSVDataFile(getCSVFileUrl)
        }
        /** ***** */
      }
    },
    downloadCSVDataFile: async function (urlObj) {
      try {
        window.open(urlObj, '_blank')
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.loadingComponent.close()
        console.log('error in fetching records : ', errorMessage)
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    onFranchiseeChange: async function () {
      if (!this.inProgress) {
        this.inProgress = true
        if (this.franchisee) {
          this.franchiseeID = this.franchisee.id
        } else {
          this.franchiseeID = ''
        }
        if (this.academicYear) {
          this.academicYearID = this.academicYear.id
        } else {
          this.academicYearID = ''
        }
        this.inProgress = false
      }
    },
    viewDocuments: async function (enquiryCode) {
      this.toggleDocumentModal()
      let response = await http.get(`${constants.API_URL}/api/registration-details/${enquiryCode}`)
      this.registrationData = response.data
      if (!_.isEmpty(this.registrationData.enquiryRegistrations)) {
        this.documentData = this.registrationData.enquiryRegistrations[0]
      }

      this.studentPhotoURL = !_.isEmpty(this.documentData.studentPhotoUrl) && this.documentData.studentPhotoUrl !== '0' ? this.documentData.studentPhotoUrl : ''
      this.fatherPhotoURL = !_.isEmpty(this.documentData.fatherPhotoUrl) && this.documentData.fatherPhotoUrl !== '0' ? this.documentData.fatherPhotoUrl : ''
      this.motherPhotoURL = !_.isEmpty(this.documentData.motherPhotoUrl) && this.documentData.motherPhotoUrl !== '0' ? this.documentData.motherPhotoUrl : ''
      this.birthCertificateURL = !_.isEmpty(this.documentData.birthCertificateUrl) && this.documentData.birthCertificateUrl !== '0' ? this.documentData.birthCertificateUrl : ''
      this.transferCertificateURL = !_.isEmpty(this.documentData.transferCertificateUrl) && this.documentData.transferCertificateUrl !== '0' ? this.documentData.transferCertificateUrl : ''
      this.immunisationCertificateURL =
        !_.isEmpty(this.documentData.immunisationCertificateUrl) && this.documentData.immunisationCertificateUrl !== '0' ? this.documentData.immunisationCertificateUrl : ''
      this.studentAadharCardURL = !_.isEmpty(this.documentData.studentAadharCardUrl) && this.documentData.studentAadharCardUrl !== '0' ? this.documentData.studentAadharCardUrl : ''
      this.fatherAadharCardURL = !_.isEmpty(this.documentData.fatherAadharCardUrl) && this.documentData.fatherAadharCardUrl !== '0' ? this.documentData.fatherAadharCardUrl : ''
      this.motherAadharCardURL = !_.isEmpty(this.documentData.motherAadharCardUrl) && this.documentData.motherAadharCardUrl !== '0' ? this.documentData.motherAadharCardUrl : ''
      this.healthCertificateURL = !_.isEmpty(this.documentData.healthCertificateUrl) && this.documentData.healthCertificateUrl !== '0' ? this.documentData.healthCertificateUrl : ''
    },
    selectSectionModal: async function () {
      this.sectionModal()
    },
    isDate: function (date) {
      if (!date) {
        return ''
      } else return moment(date).format('D-MMM-YYYY')
    },
    getDateTime: function (date) {
      if (!date) {
        return ''
      } else return moment(date).format('D-MMM-YYYY HH:mm')
    },
    getAdmission: async function () {
      try {
        if (this.franchiseeID && this.academicYear) {
          const response = await http.post(`${constants.API_URL}/api/admissionlist/`, {
            franchiseeID: this.franchiseeID,
            academicYearID: this.academicYear.id,
            fromDate: this.filter.fromDate,
            toDate: this.filter.toDate
          })
          this.admissionData = response.data.rows
          this.admissionData.filter(item => {
            item.dateOfAdmission = moment(item.studentEnrollment.dateOfAdmission).format('DD/MM/YYYY HH:mm')
            if (item.studentEnrollment.gender === 'MALE' || item.studentEnrollment.gender === 'Male') {
              item.studentEnrollment.gender = 'Boy'
            }

            if (item.studentEnrollment.gender === 'FEMALE' || item.studentEnrollment.gender === 'Female') {
              item.studentEnrollment.gender = 'Girl'
            }
            console.log(this.admissionData, 'Dataasdd')
          })

          this.searchTerm = null
          this.total = response.data.count
          this.loadingComponent.close()
        }
      } catch (e) {
        this.loadingComponent.close()
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    },
    toggleDocumentModal: function () {
      this.enableDocumentModal = !this.enableDocumentModal
    },
    sectionModal: function () {
      this.enableSectionModal = !this.enableSectionModal
    },
    resetAll: function () {
      this.filter = {
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),

        stage: 'All'
      }
      this.getAdmission()
    },
    academics: async function () {
      const { data } = await http.get(`${constants.API_URL}/api/franchiseeAcademicYears`)
      this.academicYears = data.rows
      const currentAcademicYear = Utils.getCurrentAcademicYear()
      let academicYear = this.academicYears.find(y => {
        return y.academicYear.trim() === currentAcademicYear.trim()
      })
      this.filter.academicYearID = this.findEnquiry.academicYearID = academicYear ? academicYear.id : ''
    },

    getS3Url: async function (key) {
      await http
        .get(`${constants.API_URL}/api/ticket/downloadurl?s3urlKey=${key}`)
        .then(function (response) {
          return response.data
        })
        .catch(httpException => {
          return Utils.notify(httpException.message, 'error')
        })
    },

    sendRegistrationFormLinkToParent: async function (enqID) {
      try {
        this.loadingComponent = this.$buefy.loading.open()
        this.lock = true

        const formData = {
          enquiryID: enqID
        }

        /** * generate Application link */
        await http.post(`${constants.API_URL}/api/generateRegistrationFormLink`, formData)

        this.loadingComponent.close()
        return this.$buefy.dialog.alert({
          type: 'is-success',
          message: 'Email is sent to parent for filling further details !',
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',
          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      } catch (e) {
        this.loadingComponent.close()

        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$buefy.dialog.alert({
          type: 'is-danger',
          message: errorMessage,
          hasIcon: true,
          animation: 'zoom-out',
          size: 'is-medium',

          icon: ' mdi-exclamation',
          iconPack: 'mdi',
          ariaRole: 'alertdialog',
          ariaModal: true
        })
      }
    }
  }

}
</script>
